import { FormInstance } from 'antd';
import React from 'react';
import { UseMutationResult } from 'react-query';
import {
  ClientType,
  NouveauDossierConcessionnaireData,
  RAI,
} from 'types/Concessionnaire';
import Step3PersonneMorale from 'views/dossiers/concessionnaire/steps/Step3PersonneMorale';
import Step3PersonnePhysique from 'views/dossiers/concessionnaire/steps/Step3PersonnePhysique';

type Props = UseMutationResult<
  {
    id: string;
    volume: number;
    prime: number;
  },
  Error,
  {
    particulier: boolean;
    formData: FormData;
  },
  unknown
> & {
  form: FormInstance<NouveauDossierConcessionnaireData>;
  isLoadingPrime?: boolean;
  primeParGwh?: number;
  primeParVehicule?: number;
  goToPreviousStep(): void;
  volume?: number;
  rai?: RAI;
  showActions?: boolean;
  showError?: boolean;
};

export default function Step3(props: Props) {
  const { form } = props;
  const typeClient = form.getFieldValue('typeClientFinal');
  const personnePhysique = typeClient === ClientType.PERSONNE_PHYSIQUE;

  if (personnePhysique) {
    return <Step3PersonnePhysique {...props} />;
  }

  return <Step3PersonneMorale {...props} />;
}
